import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Utils from '@src/app/helpers/Utils';
import { UserService  } from '@src/app/services/userService.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  
    @Output() clearExam: EventEmitter<any> = new EventEmitter();
    public isHiddenMenu = true;
    public isProgressNeeded = false;
    public progressValue = 0;
    public title;
    public logoutBtn = false;
    public bookType = 'KBK';
    constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private userService: UserService) {
      this.translate.get('PageTitle').subscribe((data: any) => {
        this.title = data;
      });
     }




  ngOnInit() {
    this.bookType = Utils.getBookType();
  }
  onClearExam() {
    this.clearExam.emit();
  }
  onLogout() {
    this.userService.logout();
    this.router.navigate(['/']);
  }

}
